import { ColorProps } from '../utils/UNSAFE_interpolations/colors';
import { Dimension } from '../utils/UNSAFE_visTypes/common';

export function getXAxisLineProps(
  availSpace: Dimension,
  axisPosition: 'left' | 'right' | 'top' | 'bottom',
  axisLine?: {
    lineColor?: ColorProps['color'];
    lineWidth?: number;
    isRendered: boolean;
  }
) {
  return {
    x1: axisPosition === 'right' ? availSpace.x + availSpace.width : availSpace.x,
    x2: axisPosition === 'left' ? availSpace.x : availSpace.x + availSpace.width,
    y1: axisPosition === 'bottom' ? availSpace.y + availSpace.height : availSpace.y,
    y2: axisPosition === 'top' ? availSpace.y : availSpace.y + availSpace.height,
    stroke: axisLine?.lineColor,
    strokeWidth: axisLine?.lineWidth
  };
}

export function getYAxisLineProps(
  availSpace: Dimension,
  axisPosition: 'left' | 'right' | 'top' | 'bottom',
  isRtl?: boolean,
  axisLine?: {
    lineColor?: ColorProps['color'];
    lineWidth?: number;
    isRendered: boolean;
  }
) {
  let x1, x2, y1, y2: number;
  if (axisPosition === 'bottom') {
    x1 = isRtl ? availSpace.x + availSpace.width : availSpace.x;
    x2 = isRtl ? availSpace.x + availSpace.width : availSpace.x;
    y1 = availSpace.y;
    y2 = availSpace.y + availSpace.height;
  } else {
    x1 = availSpace.x;
    x2 = availSpace.x + availSpace.width;
    y1 = isRtl ? availSpace.y : availSpace.y + availSpace.height;
    y2 = isRtl ? availSpace.y : availSpace.y + availSpace.height;
  }
  return {
    x1,
    x2,
    y1,
    y2,
    stroke: axisLine?.lineColor,
    strokeWidth: axisLine?.lineWidth
  };
}

export function getY2AxisLineProps(
  availSpace: Dimension,
  axisPosition: 'left' | 'right' | 'top' | 'bottom',
  isRtl?: boolean,
  axisLine?: {
    lineColor?: ColorProps['color'];
    lineWidth?: number;
    isRendered: boolean;
  }
) {
  let x1, x2, y1, y2: number;
  if (axisPosition === 'bottom') {
    x1 = isRtl ? availSpace.x : availSpace.x + availSpace.width;
    x2 = isRtl ? availSpace.x : availSpace.x + availSpace.width;
    y1 = availSpace.y;
    y2 = availSpace.y + availSpace.height;
  } else {
    x1 = availSpace.x;
    x2 = availSpace.x + availSpace.width;
    y1 = isRtl ? availSpace.y + availSpace.height : availSpace.y;
    y2 = isRtl ? availSpace.y + availSpace.height : availSpace.y;
  }
  return {
    x1,
    x2,
    y1,
    y2,
    stroke: axisLine?.lineColor,
    strokeWidth: axisLine?.lineWidth
  };
}

export function getBaseLineProps(
  availSpace: Dimension,
  coord: number,
  axisPosition: 'left' | 'right' | 'top' | 'bottom'
) {
  let x1, x2, y1, y2: number;
  if (axisPosition === 'bottom') {
    x1 = availSpace.x;
    x2 = availSpace.x + availSpace.width;
    y1 = coord;
    y2 = coord;
  } else {
    x1 = coord;
    x2 = coord;
    y1 = availSpace.y;
    y2 = availSpace.y + availSpace.height;
  }

  return { x1, x2, y1, y2 };
}

export function getBaseLineCoords(
  isHoriz: boolean,
  coord: number,
  range1: number,
  range2: number,
  isYAxis: boolean
) {
  let x1, x2, y1, y2: number;
  if (isHoriz) {
    if (isYAxis) {
      x1 = coord;
      x2 = coord;
      y1 = range1;
      y2 = range2;
    } else {
      x1 = range1;
      x2 = range2;
      y1 = coord;
      y2 = coord;
    }
  } else {
    if (isYAxis) {
      x1 = range1;
      x2 = range2;
      y1 = coord;
      y2 = coord;
    } else {
      x1 = coord;
      x2 = coord;
      y1 = range1;
      y2 = range2;
    }
  }

  return { x1, x2, y1, y2 };
}
